<template>
  <v-navigation-drawer
    class="navigation-widget"
    color="white"
    v-model="value"
    temporary
    fixed
  >
    <router-link to="/" class="d-flex px-2 py-4">
      <img
        v-if="informations.img"
        :src="files + informations.img"
        :alt="informations.name"
        class="d-block mx-auto navbar-brand"
      />
    </router-link>

    <div
      v-if="informations.img_faculty || informations.img_foundation"
      class="d-flex align-center justify-center mb-6"
    >
      <v-card
        v-if="informations.img_faculty"
        class="mx-2"
        v-bind="getLinkAttrs(externalLinks.college_website)"
        flat
        tile
      >
        <img
          class="d-block"
          :src="files + informations.img_faculty"
          width="100px"
        />
      </v-card>

      <v-card
        v-if="informations.img_foundation"
        class="mx-2 mt-3"
        v-bind="getLinkAttrs(externalLinks.foundation_website)"
        flat
        tile
      >
        <img
          class="d-block"
          :src="files + informations.img_foundation"
          width="100px"
        />
      </v-card>
    </div>

    <PwaButtonWidget />

    <v-list v-model="current" class="mt-2 px-0">
      <template v-for="({ text, to, dropdown }, i) in menu">
        <v-list-item
          v-if="!dropdown"
          class="my-0"
          :key="i"
          v-bind="getLinkAttrs(to, server)"
          link
        >
          <v-list-item-title
            class="primary--text text-body-2 font-weight-medium px-4"
          >
            {{ text }}
          </v-list-item-title>
        </v-list-item>

        <v-list-group
          v-else
          :key="`${i}d`"
          :value="false"
          class="dropdown-menu"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-title
              class="primary--text text-body-2 font-weight-medium px-4"
            >
              {{ text }}
            </v-list-item-title>
          </template>

          <v-list-item
            v-for="({ text, to }, i) in dropdown"
            :key="i"
            v-bind="getLinkAttrs(to, server)"
            class="pl-8 primary mb-0"
            link
          >
            <v-list-item-title
              class="white--text text-body-2 font-weight-medium"
            >
              {{ text }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import PwaButtonWidget from "./PwaButtonWidget.vue";
import { getLinkAttrs } from "../../utils/getLinkAttrs";
import { menu } from "../../config";

/**
 * Instancie esse componente na App.vue
 * e use a função window.showNavigationDrawer para mostrar o menu lateral.
 */
export default {
  data() {
    return {
      current: this.$route.path,
      value: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    externalLinks() {
      return this.$rest("external-links").item;
    },
  },
  methods: {
    show() {
      this.value = !this.value;
    },
    getLinkAttrs,
  },
  created() {
    window.showNavigationDrawer = () => this.show();
  },
  components: {
    PwaButtonWidget,
  },
  mixins: [menu],
};
</script>

<style lang="scss" scoped>
.navigation-widget {
  .navbar-brand {
    width: 90%;
  }
}

.v-navigation-drawer--temporary {
  z-index: 999 !important;
}

.v-navigation-drawer--fixed {
  z-index: 999 !important;
}

.dropdown-menu::v-deep {
  .v-icon {
    font-size: 14px !important;
  }

  .v-list-group__header {
    margin-bottom: 0 !important;
    margin-top: 8px;
  }

  .v-list-group__items {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
